import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { StoreConfig } from "../../../shared/interface/StoreConfig.interface";
import { environment } from '../../../../environments/environment';
import { PaginationInstance } from "ngx-pagination";
import { FileUploadConstants } from "../../constants/file-upload.constants";
import { ReportService } from "../../services/report.service";
import { CommonService } from "../../../shared/services/common.service";
import { TranslateService } from "@ngx-translate/core";
import { NotificationType } from "../../enums/notification-types.enum";
import { CustomerService } from "../../services/customer.service";
import { ResponseStatus } from "../../constants/response-status-constants";
import { CacheKey } from "../../../shared/constants/cachekey.constants";
import { CacheService } from "../../../shared/services/cache.service";
import * as moment from 'moment';

@Component({
    selector: 'app-enrollment-reports',
    templateUrl: '../../templates/template1/views/reports/enrollment-reports.component.html',
    styleUrls: [
        '../../templates/template1/themes/default/less/enrollment-reports.less'
    ]
})

export class EnrollmentReportsComponent implements OnInit {
    @Input() fromDate: string;
    @Input() toDate: string;
    @Input() storeId: [number];
    @Output() isLoadedData = new EventEmitter<boolean>();
    @Input() storeInfo: StoreConfig;
    @Input() email: string;
    @Input() fboId: string;
    pageSizes = [25, 50, 75, 100, 125, 150, 175, 200];
    pageNumber: number = 1;
    pageSize: number = 25;
    pageCount: number = 0;
    pollCount: number = 0;
    maxPollCount = 15;

    enrollmentReport = null;
    isResponseError = false;
    isLoading = false;
    isAllEnrollmentReportLoading = false;
    isShowReport = true;
    allEnrollmentReport = null;
    currentDate = new Date();
    excelIconUrl = environment.cdnURL + '/flpi/images/ms_excel.ico';
    printIconUrl = environment.cdnURL + '/flpi/images/print_icon.png';
    csvType = FileUploadConstants.CSV_FILE_EXTENSION;
    printType = FileUploadConstants.PRINT;

    public paginationInstance: PaginationInstance = {
        id: 'enrollment-reports-pagination',
        itemsPerPage: 10,
        currentPage: 1
    }

    constructor(
        private _reportService: ReportService,
        private _translateService: TranslateService,
        private _commonService: CommonService,
        private _customerservice: CustomerService,
        private _cacheService: CacheService
      ) { }

    ngOnInit(): void {
        this.getTitanEnrollmentReport();
    }

    getTitanEnrollmentReport(): void {
        this.isLoading = true;
        this.getEnrollmentReport(this._reportService.getConstructedEnrollmentReportUrl(this.storeId, this.fromDate, this.toDate, 
            this.email, this.fboId, this.pageSize, this.pageNumber, false));
    
    }

    getEnrollmentReport(url: string): void {
        this._reportService.getEnrollmentPollReport(url).subscribe(response => {
            if (response.status === ResponseStatus.COMPLETED) {
                this.processEnrollmentReportSuccess(response.responseModel);
              } else {
                this.processEnrollmentReportPending(response);
              }
        }, (error) => {
            if (error.status == 504 || (error.name && error.name.toLowerCase() == 'typeerror')) {
                const message: any = this._translateService.get('reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again');
                this._commonService.createNotification('', message.value, NotificationType.ERROR);
                this.setDefaultValues();
            }
            else {
                const message: any = this._translateService.get('reports.Something Went Wrong, Please try again after some time');
                this._commonService.createNotification('', message.value, NotificationType.ERROR);
                this.setDefaultValues();
            }
        });
    }

    processEnrollmentReportSuccess(response: any): void{
        if (response && response.content) {
            response.content.forEach(element => {
                let enrollmentDate = element.enrollmentDate ;
                if(enrollmentDate){
                    element.enrollmentDate = this.getformattedEnrollmentDate(enrollmentDate)
                }
            });
            this.enrollmentReport =  response.content;
            this.isLoading = false;
            this.isResponseError = false;
            this.pageCount = response.totalCount;
            this.isLoadedData.emit(true);
            this.exportFile('csv');
        }
        else if (response && response.status && response.status.code === 504) {
            const message: any = this._translateService.get('reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again');
            this._commonService.createNotification('', message.value, NotificationType.ERROR);
            this.setDefaultValues();
        }else{
            this.setDefaultValues();
        }

    }

    processEnrollmentReportPending(response: any): void{
        if ((response.status === ResponseStatus.IN_PROGRESS) || (response.status === ResponseStatus.QUEUED)) {
            if (this.pollCount < this.maxPollCount) {
              this.pollCount = this.pollCount + 1;
              this.getEnrollmentReport(response.location);
            }
          } else {
            this._cacheService.remove(CacheKey.pollCount);
          }
          this._cacheService.remove(CacheKey.pollCount);
    }

     /**
     * To Set Default Values
     */
    setDefaultValues(): void {
        this.isLoading = false;
        this.isResponseError = true;
        this.pageCount = 0;
        this.isLoadedData.emit(true);
    }

     
     /**
    * To change page size
    * @param  {number} pageSize
    * @returns void
    */
    pageSizeChange(pageSize: number): void {
        if (pageSize) {
            this.pageNumber = 1;
            this.pageSize = pageSize;
            this.getTitanEnrollmentReport();
        }
    }

    /**
     * To change page number
     * @param  {number} pageNumber
     */
    pageChange(pageNumber: number) {
        this.pageNumber = pageNumber;
        this.pollCount = 0;
        this.getTitanEnrollmentReport();
    }

    /**
     * To Export The file
     */
    exportFile(type): void {
        if (this.allEnrollmentReport && this.allEnrollmentReport.length > 0) {
            this.download(type);
        } else {
            this.fetchAllEnrollmentReport(type);
        }
    }

      /**
     * To Fetch all enrollment report data from service
     */
    fetchAllEnrollmentReport(type): void {
        this.isAllEnrollmentReportLoading = true;
        this._reportService.getEnrollmentReport(this.storeId, this.fromDate, this.toDate, this.email, this.fboId, this.pageSize, this.pageNumber, false).subscribe(response => {
            if (response && response.content) {
                response.content.forEach(element => {
                    let enrollmentDate = element.enrollmentDate ;
                    if(enrollmentDate){
                        element.enrollmentDate = this.getformattedEnrollmentDate(enrollmentDate)
                    }
                });
                this.isAllEnrollmentReportLoading = false;
                this.allEnrollmentReport = response.content;
                this.download(type);
            } else {
                this.isAllEnrollmentReportLoading = false;
                this.allEnrollmentReport = null;
            }
        }, (error) => {
            const message: any = this._translateService.get('reports.Something Went Wrong, Please try again after some time');
            this._commonService.createNotification('', message.value, NotificationType.ERROR);
            this.allEnrollmentReport = null;
            this.isAllEnrollmentReportLoading = false;
        });
    }

    getUtcDate(timeStamp: any): string {
        if (typeof (timeStamp) == 'number') {
          timeStamp = moment.utc(timeStamp).toISOString();
        }
        if (typeof (timeStamp) == 'string') {
          if (timeStamp && timeStamp.indexOf('T') > -1 && timeStamp.indexOf('.') > -1) {
            timeStamp = timeStamp.split('.')[0];
          }
        }
        timeStamp = timeStamp.replace('T', ' ');
        return timeStamp;
    }

    getformattedEnrollmentDate(enrollmentDate: String): String{
        const dateParts = enrollmentDate.split("-");
        enrollmentDate = moment(new Date(dateParts[0] + "-" + dateParts[1] + "-"+dateParts[2])).format("DD-MM-YYYY");
        return enrollmentDate;
    }


    /**
     * To download CSV or Print file from response data
     * @param  {string} type
     * @returns void
     */
    download(type: string): void {
        const allEnrollmentReportLength = this.allEnrollmentReport && this.allEnrollmentReport.length ?
            this.allEnrollmentReport && this.allEnrollmentReport.length : null;
        if (allEnrollmentReportLength > 0) {
            const columns = [
                this._translateService.get('enrollment-reports.First Name')['value'],
                this._translateService.get('enrollment-reports.Last Name')['value'],
                this._translateService.get('enrollment-reports.FBO ID')['value'],
                this._translateService.get('enrollment-reports.Enrollment Date')['value'],
                this._translateService.get('enrollment-reports.Member Type')['value'],
                this._translateService.get('enrollment-reports.Home Country')['value'],
                this._translateService.get('enrollment-reports.Email Address')['value']
            ];
            const title = this._translateService.get('reports.Enrollment Report')['value'] + "_" + this.fromDate + this._translateService.get('reports._To_')['value'] + this.toDate;
            if (type === this.csvType) {
                this.downloadCSV(columns, allEnrollmentReportLength);
            } else if (type === this.printType) {
                this.printReportDetails(title, columns, allEnrollmentReportLength);
            }
        }
    }

     /**
     * CSV file download functionality
     */
    downloadCSV(columns: any, allEnrollmentReportLength: any) {
        let rowdata = new Array<any>();
        const finalrows = new Array<any>();
        for (let i = 0; i < allEnrollmentReportLength; i++) {
            rowdata = [];
            const row = this.allEnrollmentReport[i];
            rowdata.push(row.firstName? row.firstName: '');
            rowdata.push(row.lastName? row.lastName: '');
            rowdata.push(row.fboId? (String.fromCharCode(39) + row.fboId + String.fromCharCode(39)): '');
            rowdata.push(row.enrollmentDate? row.enrollmentDate: '');
            rowdata.push(row.memberType? row.memberType: '');
            rowdata.push(row.homeCountry? row.homeCountry: '');
            rowdata.push(row.emailAddress? row.emailAddress: '');
            finalrows.push(rowdata);
        }
        this._customerservice.ExcelDownload(columns, finalrows, (this._translateService.get('reports.Enrollment Report')['value']), '', false);
    }

    /**
      * Print functionality for report details printing
      */
  printReportDetails(title: string, columns: any, allEnrollmentReportLength: any) {
    let rowdataForPrint = new Array<any>();
    const finalrowsForPrint = new Array<any>();
    for (let i = 0; i < allEnrollmentReportLength; i++) {
        rowdataForPrint = [];
        const rowForPrint = this.allEnrollmentReport[i];
        rowdataForPrint.push(rowForPrint.firstName? rowForPrint.firstName: '');
        rowdataForPrint.push(rowForPrint.lastName? rowForPrint.lastName: '');
        rowdataForPrint.push(rowForPrint.fboId? rowForPrint.fboId: '');
        rowdataForPrint.push(rowForPrint.enrollmentDate? rowForPrint.enrollmentDate: '');
        rowdataForPrint.push(rowForPrint.memberType? rowForPrint.memberType: '');
        rowdataForPrint.push(rowForPrint.homeCountry? rowForPrint.homeCountry: '');
        rowdataForPrint.push(rowForPrint.emailAddress? rowForPrint.emailAddress: '');
        finalrowsForPrint.push(rowdataForPrint);
    }
    this._customerservice.constructTableAndPrint(columns, finalrowsForPrint, title);
  }

}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/reports/enrollment-report.component.ts